import { gql } from "@apollo/client";

export const listRetailers = gql`
  query ListRetailers($field: String!, $type: KeywordGroupType!) {
    getDistinctKeywordGroupsField(field: $field, type: $type)
  }
`;
